<template>
  <div class="detailClient">
    <div class="name">
      <span class="countName">{{ ruleForm.clientName }}</span>
    </div>
    <el-tabs v-model.trim="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <el-button
          type="primary"
          size="small"
          class="editCount"
          v-show="!isEdit"
          @click="editCount"
        >
          编辑应用
        </el-button>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleFormEditClient"
          label-width="120px"
        >
          <el-form-item label="应用ID" prop="clientID">
            <el-input
              v-model.trim="ruleForm.clientID"
              :maxlength="32"
              disabled
              placeholder="请输入应用ID"
            ></el-input>
            <i
              class="icon icon-copy"
              title="复制ID"
              v-clipboard:copy="ruleForm.clientID"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            ></i>
          </el-form-item>
          <el-form-item label="应用密钥" prop="secret">
            <el-input
              v-model.trim="ruleForm.secret"
              disabled
              placeholder="请输入密钥"
            ></el-input>
            <i
              class="icon icon-copy"
              title="复制密钥"
              v-clipboard:copy="ruleForm.secret"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            ></i>
          </el-form-item>
          <el-form-item label="应用名称" prop="clientName">
            <el-input
              v-model.trim="ruleForm.clientName"
              :maxlength="32"
              :disabled="!isEdit"
              placeholder="请输入应用名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="应用描述" prop="clientDesc">
            <el-input
              type="textarea"
              v-model="ruleForm.clientDesc"
              :maxlength="100"
              :disabled="!isEdit"
              placeholder="请输入应用描述"
            ></el-input>
          </el-form-item>
          <el-form-item label="根URL" prop="rootUrl">
            <el-input
              v-model.trim="ruleForm.rootUrl"
              :disabled="!isEdit"
              placeholder="请输入根URL"
            ></el-input>
          </el-form-item>
          <el-form-item label="重定向URI" prop="redirectUrl">
            <el-input
              type="textarea"
              class="redirectUrl"
              v-model="ruleForm.redirectUrl"
              :disabled="!isEdit"
              placeholder="请输入重定向URI"
            ></el-input>
          </el-form-item>
          <el-form-item label="应用注销URL" prop="frontChannelLogoutUrl">
            <el-input
              type="text"
              class="redirectUrl"
              v-model.trim="ruleForm.frontChannelLogoutUrl"
              :disabled="!isEdit"
              placeholder="请输入应用注销URL"
            ></el-input>
          </el-form-item>
          <el-form-item label="应用状态" prop="enable">
            <el-switch
              v-model="ruleForm.enable"
              :disabled="!isEdit"
            ></el-switch>
          </el-form-item>
          <el-form-item>
            <div class="footer" v-show="isEdit">
              <el-button type="primary" @click="submitForm">确 定</el-button>
              <el-button @click="handleCancel">取 消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="角色信息" name="second">
        <el-button type="primary" size="small" class="setRole" @click="setRole">
          新建角色
        </el-button>
        <el-table :data="tableData" tooltip-effect="light" style="width: 100%">
          <el-table-column
            label="角色标识"
            prop="roleFlag"
            width="220px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="角色名称"
            prop="roleName"
            width="260px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="角色描述"
            prop="roleDesc"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="200px"
            align="center"
            class-name="options td-pt1"
          >
            <template slot-scope="scope">
              <span class="textBtn" @click="handleRoleEdit(scope.row.id)">
                编辑
              </span>
              <span
                class="textBtn delete"
                @click="handleRoleDelete(scope.row.id)"
              >
                删除
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="登录配置" name="third">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>IDaaS支持应用配置双因子认证。开启双因子认证前，请确认已完成短信配置。</p>
            <p>开启双因子认证后，登录时首先使用账户密码完成第一次认证，认证通过后需再次验证短信验证码，二次认证通过后才能成功登录。</p>
          </div>
        </div>
        <el-form>
          <el-form-item label="双因子认证" prop="login">
            <el-switch :disabled="disabledChange" v-model="authentication" @change="changeLogin"></el-switch>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :title="roleTitle"
      width="500px"
      :visible.sync="dialogSetRoleVisible"
    >
      <el-form
        :model="ruleFormRole"
        :rules="rulesRole"
        ref="ruleFormRole"
        class="ruleFormRole"
        label-width="100px"
      >
        <el-form-item label="角色标识" prop="roleFlag">
          <el-input
            v-model.trim="ruleFormRole.roleFlag"
            :maxlength="32"
            :disabled="isEditRole"
            placeholder="请输入角色标识"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色名称" prop="roleName">
          <el-input
            v-model.trim="ruleFormRole.roleName"
            :maxlength="32"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="roleDesc">
          <el-input
            type="textara"
            v-model="ruleFormRole.roleDesc"
            :maxlength="100"
            placeholder="请输入角色描述"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitSetRole">确 定</el-button>
        <el-button @click="dialogSetRoleVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="删除角色" width="500px" :visible.sync="dialogRemoveRole">
      <div class="deleteText">
        确认删除该角色吗？
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemoveRole">确 定</el-button>
        <el-button @click="dialogRemoveRole = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import APIS from "@/apis/clientManage.js"
import { validateUrl } from "@/common/utils.js"
export default {
  data() {
    const validatelogoutUrl = (rule, value, callback) => {
      //校验以http://、https://开头的url
      let pattern = /(http|https):\/\/([\w.]+\/?)\S*/
      if (value === null || value === "") {
        callback()
      } else if(!pattern.test(value)){
        callback([new Error("URL格式不正确")])
      } else {
        callback()
      }
    }
    const checkRoleFlag = (rule, value, callback) => {
      let pattern = /^[0-9a-zA-Z-]{1,32}$/
      value = value.trim()
      if (value === "") {
        callback(new Error("请输入角色标识"))
      } else if (!pattern.test(value)) {
        callback(new Error("支持英文、数字、中划线(-)"))
      } else {
        callback()
      }
    }
    return {
      dialogSetRoleVisible: false,
      dialogRemoveRole: false,
      breadcrumb: [
        {
          label: "应用管理",
          url: "/clientManage"
        },
        {
          label: "应用详情"
        }
      ],
      activeName: "first",
      ruleForm: {
        clientID: "",
        secret: "",
        rootUrl: "",
        clientName: "",
        clientDesc: "",
        redirectUrl: "",
        frontChannelLogoutUrl: "",
        enable: true
      },
      rules: {
        rootUrl: [
          { required: true, message: "请输入根URL", trigger: "blur" },
          { validator: validateUrl, trigger: "blur" }
        ],
        clientName: [
          { required: true, message: "请输入应用名称", trigger: "blur" }
        ],
        redirectUrl: [
          { required: true, message: "请输入重定向URI", trigger: "blur" }
          // { validator: validateRedirectUrl, trigger: "blur" }
        ],
        frontChannelLogoutUrl: [
          { required: false, message: "请输入应用注销URL", trigger: "blur" },
          { validator: validatelogoutUrl, trigger: "blur" }
        ]
      },
      ruleFormRole: {
        roleFlag: "",
        roleName: "",
        roleDesc: ""
      },
      rulesRole: {
        roleFlag: [
          { required: true, validator: checkRoleFlag, trigger: "blur" }
        ],
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" }
        ]
      },
      isEdit: false,
      tableData: [],
      realmName: this.$realm,
      clientId: "",
      preParams: null, // 缓存当前的参数
      isEditRole: false,
      authentication: '',//双因子认证
      disabledChange: false,
    }
  },
  computed: {
    roleTitle() {
      return this.isEditRole ? "编辑角色" : "新建角色"
    }
  },
  created() {
    this.clientId = this.$route.query.clientId
  },
  mounted() {
    if (this.clientId) {
      this.getRealmsClientInfor()
      this.getClientRolesList()
    }
  },
  methods: {
    // 双因子认证开启关闭
    async changeLogin() {
      let params = {
        client: this.ruleForm.clientID,
        phoneAgain: this.authentication
      }
      let { status } = await APIS.setDoubleFactor(this.$realm, {data: params})
      if (status === 0) {
       this.getDoubleFactor()
      }
    },
    // 查询双因子认证状态
    async getDoubleFactor() {
      let { status, data } = await APIS.getDoubleFactor(this.$realm, this.ruleForm.clientID)
      if (status === 0) {
        this.authentication = data ? (data.phoneAgain === 'true' ? true : false) : false
        this.disabledChange = data ? false : true
      }
    },
    // 获取账户信息详情
    async getRealmsClientInfor() {
      let { status, data } = await APIS.getRealmsClientInfo(
        this.realmName,
        this.clientId
      )
      if (status === 0) {
        this.ruleForm.clientID = data && data.clientId
        this.ruleForm.secret = data && data.secret
        this.ruleForm.rootUrl = data && data.rootUrl
        this.ruleForm.clientName = data && data.name
        this.ruleForm.clientDesc = data && data.description
        this.ruleForm.redirectUrl = data && data.redirectUris.join("\n")
        this.ruleForm.enable = data && data.enabled
        this.ruleForm.frontChannelLogoutUrl = data && data.frontChannelLogoutUrl
        this.getDoubleFactor()
      }
    },
    // 更新账户信息
    async putClientInfor() {
      let params = {
        // "clientId": this.ruleForm.clientID,
        name: this.ruleForm.clientName,
        rootUrl: this.ruleForm.rootUrl,
        enabled: this.ruleForm.enable,
        redirectUris: this.ruleForm.redirectUrl
          .split("\n")
          .filter(item => item !== ""),
        // "protocol": this.ruleForm.clientID,
        description: this.ruleForm.clientDesc,
        frontChannelLogoutUrl: this.ruleForm.frontChannelLogoutUrl
      }
      let { status } = await APIS.putRealmsClientInfo(
        this.realmName,
        this.clientId,
        { data: params }
      )
      if (status === 0) {
        this.isEdit = false
      }
    },
    // 获取应用角色信息
    async getClientRolesList() {
      let { status, data } = await APIS.getRealmsClientRole(
        this.realmName,
        this.clientId
      )
      this.tableData = []
      if (status === 0) {
        this.tableData = data.map(item => {
          return {
            id: item.mark, // mark作为角色的唯一标识符，可以用作id
            roleFlag: item.mark,
            roleName: item.name,
            roleDesc: item.description
          }
        })
      }
    },
    // 更新角色信息
    async putEditRole() {
      let params = {
        mark: this.ruleFormRole.roleFlag,
        name: this.ruleFormRole.roleName,
        description: this.ruleFormRole.roleDesc
      }
      let { status } = await APIS.putRealmsClientRole(
        this.realmName,
        this.clientId,
        this.currentRole.id,
        { data: params }
      )
      if (status === 0) {
        this.dialogSetRoleVisible = false
        this.getClientRolesList()
      }
    },
    // 添加角色
    async postAddRole() {
      let params = {
        mark: this.ruleFormRole.roleFlag,
        name: this.ruleFormRole.roleName,
        description: this.ruleFormRole.roleDesc
      }
      let { status } = await APIS.postRealmsClientRole(
        this.realmName,
        this.clientId,
        { data: params }
      )
      if (status === 0) {
        this.dialogSetRoleVisible = false
        this.getClientRolesList()
      }
    },
    // 添加角色
    async deleteRole() {
      let { status } = await APIS.deleteRealmsClientRole(
        this.realmName,
        this.clientId,
        this.currentRole.id
      )
      if (status === 0) {
        this.dialogRemoveRole = false
        this.getClientRolesList()
      }
    },
    // 初始化角色表单
    initFormRole() {
      this.$refs["ruleFormRole"].resetFields()
      this.ruleFormRole.roleFlag = ""
      this.ruleFormRole.roleName = ""
      this.ruleFormRole.roleDesc = ""
    },
    // 编辑账户按钮
    editCount() {
      this.preParams = JSON.stringify(this.ruleForm)
      this.isEdit = true
    },
    handleClick() {
      this.isEdit = false
    },
    // 提交编辑表单
    submitForm() {
      this.$refs["ruleFormEditClient"].validate(valid => {
        if (valid) {
          // 如果账户信息未改变，则不需要更新账户信息
          if (this.preParams === JSON.stringify(this.ruleForm)) {
            this.isEdit = false
            return false
          }
          this.putClientInfor()
        }
      })
    },
    submitForm1() {
      console.log('保存')
    },
    handleCancel() {
      this.isEdit = false
      this.$refs["ruleFormEditClient"].resetFields()
      this.ruleForm = Object.assign({}, JSON.parse(this.preParams))
    },
    // 打开删除角色弹窗
    handleRoleDelete(id) {
      this.currentRole = this.tableData.find(item => item.id === id)
      if (!this.currentRole) {
        return false
      }
      this.dialogRemoveRole = true
    },
    // 打开编辑角色弹窗
    handleRoleEdit(id) {
      this.currentRole = this.tableData.find(item => item.id === id)
      if (!this.currentRole) {
        return false
      }
      this.isEditRole = true
      this.dialogSetRoleVisible = true
      this.$nextTick(() => {
        this.initFormRole()
        this.ruleFormRole.roleFlag = this.currentRole.roleFlag
        this.ruleFormRole.roleName = this.currentRole.roleName
        this.ruleFormRole.roleDesc = this.currentRole.roleDesc
      })
    },
    // 打开新建角色弹窗
    setRole() {
      this.isEditRole = false
      this.dialogSetRoleVisible = true
      this.$nextTick(() => {
        this.initFormRole()
      })
    },
    // 确认新建/编辑角色
    submitSetRole() {
      this.$refs["ruleFormRole"].validate(valid => {
        if (valid) {
          // 提交新建/修改角色表单
          if (this.isEditRole) {
            this.putEditRole()
          } else {
            this.postAddRole()
          }
        }
      })
    },
    // 确认删除角色
    submitRemoveRole() {
      this.deleteRole()
    },
    copySuccess() {
      this.$message.success({
        message: "内容已成功复制到剪贴板"
      })
    },
    copyError() {
      this.$message.error({
        message: "内容复制失败"
      })
    }
  }
}
</script>

<style lang="scss">
.detailClient {
  .name {
    margin-bottom: 16px;
  }
  .el-textarea {
    textarea {
      min-height: 80px !important;
      padding: 5px 10px;
    }
    &.redirectUrl {
      textarea {
        min-height: 66px !important;
      }
    }
  }
  .el-form-item__error {
    white-space: nowrap;
  }
  .el-form {
    &.ruleFormRole {
      width: 370px;
    }
    .icon.icon-copy {
      position: absolute;
      top: 14px;
      right: -30px;
      cursor: pointer;
    }
  }
  .el-tabs {
    .el-button.editCount {
      margin-bottom: 15px;
    }
    .el-button.setRole {
      margin-bottom: 20px;
    }
  }
  .el-dialog {
    &__title {
      color: #333333;
      font-weight: 600;
    }
    &__body {
      // padding: 0 50px;
      .deleteText {
        text-align: center;
        height: 50px;
        line-height: 50px;
      }
    }
  }
  .source-form {
    .content-box {
      display: flex;
      align-content: center;
      .el-button {
        margin-top: 5px;
      }
    }
  }
}
</style>
